import { Grid, Stack } from '@mui/material';
import * as React from 'react';
import * as Redux from 'react-redux';
import { DrawerWidget, LoadingWidget } from '../../../../widgets';
import BotonComponent from '../../../dashboard/components/BotonNuevo';
import { allEstudiantesNotasEvaluativasAction } from '../../estudiantes/EstudiantesAction';
import FiltrosNotasEvaluativasComponent from './components/FiltrosNotasEvaluativas';
import ListadoNotasEvaluativas from './components/ListadoNotasEvaluativas';
import TextFiltrosNotasEvaluativasComponent from './components/TextFiltrosNotasEvaluativas';

const NotasEvaluativasView = () => {
  const dispatch = Redux.useDispatch();

  const notasEvaluativasStore = Redux.useSelector(
    (state) => state.notasEvaluativas,
  );
  const seccionesStore = Redux.useSelector((state) => state.secciones);

  const [isFiltros, setIsFiltros] = React.useState(false);
  const [isGraficos, setIsGraficos] = React.useState(false);
  const [docenteSelect, setDocenteSelect] = React.useState(null);

  React.useEffect(() => {
    if (
      !notasEvaluativasStore.params.idBloquePedagogico ||
      !notasEvaluativasStore.params.idDocente ||
      !notasEvaluativasStore.params.idSeccion
    ) {
      setIsFiltros(true);
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <Grid container spacing={1}>
      {seccionesStore.loadingAll && (
        <Grid item md={12}>
          <LoadingWidget isLoading={seccionesStore.loadingAll} />
        </Grid>
      )}
      <Grid
        item
        md={12}
        sx={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
        }}
      >
        <div>
          <BotonComponent
            click={async () => {
              await allEstudiantesNotasEvaluativasAction(
                dispatch,
                notasEvaluativasStore.params,
              );
            }}
            disabled={
              notasEvaluativasStore.loadingAll ||
              notasEvaluativasStore.all.length !== 0
            }
            white
            refreshIcon
            text={
              notasEvaluativasStore.loadingAll
                ? 'Actualizando...'
                : 'Actualizar'
            }
            mr={2}
          />
          <BotonComponent
            text="Mostrar métricas"
            click={() => {
              setIsGraficos(!isGraficos);
            }}
            white={!isGraficos}
            green={isGraficos}
          />
          {/* {notasEvaluativasStore.all.length > 0 && (
            <BotonComponent
              text="EXPORTAR TODOS EN PDF"
              click={() => {
                history.push(ROUTES.notasEvaluativasPdf.to);
              }}
              red
              downloadIcon
            />
          )} */}
        </div>

        <Stack direction="row" justifyContent="flex-end">
          <BotonComponent
            text={`FILTROS ${isFiltros ? 'ACTIVO' : ''}`}
            filterIcon
            click={() => setIsFiltros(!isFiltros)}
            white={!isFiltros}
            blue={isFiltros}
            ml={2}
          />
        </Stack>
      </Grid>
      <Grid item md={12}>
        <TextFiltrosNotasEvaluativasComponent docenteSelect={docenteSelect} />
      </Grid>
      <Grid item md={12}>
        <ListadoNotasEvaluativas isGraficos={isGraficos} />
      </Grid>

      <DrawerWidget open={isFiltros} onClose={(val) => setIsFiltros(val)}>
        <FiltrosNotasEvaluativasComponent setDocenteSelect={setDocenteSelect} />
      </DrawerWidget>
    </Grid>
  );
};

export default NotasEvaluativasView;
